import graphqlClient from '~/graphql/graphqlClient';
import type { ItemLocationInput, ItemMoveResult } from './mutationPlaceItemInGlobalInventory';

const mutation = `
mutation EquipBagToGlobalBagSlot(
  $playerId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  equipBagToGlobalBagSlot(
    playerId: $playerId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export type EquipBagToGlobalBagSlotArgs = {
  playerId: string;
  from: ItemLocationInput;
  to: ItemLocationInput;
};

export default async function mutationEquipBagToGlobalBagSlot(
  args: EquipBagToGlobalBagSlotArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>(
    'equipBagToGlobalBagSlot',
    mutation,
    args
  );
}
